/* Optional tracking uses Shopify's current consent; denied events are never queued. */
(function () {
  'use strict';
  var googleStarted = false;
  var loadingPrivacy = false;

  function allowed(method) {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!(privacy && typeof privacy[method] === 'function' && privacy[method]() === true);
    } catch (error) {
      return false;
    }
  }

  window.wintageConsent = {
    marketingAllowed: function () { return allowed('marketingAllowed'); },
    analyticsAllowed: function () { return allowed('analyticsProcessingAllowed'); }
  };

  function syncConsent() {
    var marketing = window.wintageConsent.marketingAllowed();
    var analytics = window.wintageConsent.analyticsAllowed();
    if (!marketing && !googleStarted) return;

    if (!googleStarted) {
      googleStarted = true;
      window.dataLayer = window.dataLayer || [];
      window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
      window.gtag('consent', 'default', {
        ad_storage: 'denied', analytics_storage: 'denied',
        ad_user_data: 'denied', ad_personalization: 'denied'
      });
    }
    window.gtag('consent', 'update', {
      ad_storage: marketing ? 'granted' : 'denied',
      analytics_storage: analytics ? 'granted' : 'denied',
      ad_user_data: marketing ? 'granted' : 'denied',
      ad_personalization: marketing ? 'granted' : 'denied'
    });
    if (!document.getElementById('wintage-google-tag') && marketing) {
      window.gtag('js', new Date());
      window.gtag('config', 'AW-18527197005');
      var script = document.createElement('script');
      script.id = 'wintage-google-tag';
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=AW-18527197005';
      document.head.appendChild(script);
    }
  }

  function init() {
    var shopify = window.Shopify;
    var privacy = shopify && shopify.customerPrivacy;
    if (privacy && typeof privacy.marketingAllowed === 'function' &&
        typeof privacy.analyticsProcessingAllowed === 'function') {
      syncConsent();
    } else if (!loadingPrivacy && shopify && typeof shopify.loadFeatures === 'function') {
      loadingPrivacy = true;
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], function (error) {
        if (!error) syncConsent();
      });
    }
  }

  document.addEventListener('visitorConsentCollected', syncConsent);
  init();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
})();
